import { colors } from '../../constants';
import shape from '../../shape/shape';
const MuiPaper = {
  rounded: {
    borderRadius: shape.largeComponentRadius
  },
  outlined: {
    border: `1px solid ${colors.oriGrey[200]}`
  }
};
export default MuiPaper;